import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'

export interface Props {
  children?: React.ReactNode
  className?: string
}

export default function HR(props: Props) {
  const darkMode = useIsDarkMode()

  return (
    <div className={classnames('relative py-2', props.className)}>
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div
          className={classnames({
            'w-full border-t border-gray-200': !darkMode,
            'w-full border-t border-gray-600': darkMode
          })}
        />
      </div>
      {props.children ? (
        <div className="relative flex justify-center">
          <span
            className={classnames({
              'px-2 bg-white text-sm text-gray-500': !darkMode,
              'px-2 bg-gray-800 text-sm text-gray-300': darkMode
            })}>
            {props.children}
          </span>
        </div>
      ) : null}
    </div>
  )
}
